import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  PartnerDataDatatable = (props) => {

    const [t] = useTranslation();     
  
    const tableName = t('article.label.partnersData');     

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.name'), data: "partner.address.name", sortable: true, selector: "partner.address.name"},    		
             { name: t('articlePart.label.partnerCatalog'), data: "partnerCatalog", sortable: true, selector: "partnerCatalog"},    		
             { name: t('general.label.description'), data: "description",  sortable: true,  selector: "description"},
             
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.name'), data: "partner.address.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('articlePart.label.partnerCatalog'), data: "partnerCatalog", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}               
     ];        
     const url = RestService.getBaseURL()+"article/getArticlePartnerDataList?id="+props.entityId;   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
    

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default PartnerDataDatatable;

